import { component as defineComponent } from 'flightjs';
import withHistory from 'app/mixins/with-history';

let listingXhr = null;
let countXhr = null;

function contests() {
    this.after('initialize', function() {
        this.initializeHistory();

        this.on(document, 'uiHistoryPopped', this.loadHistoryPage);
        this.on(document, 'uiBrowseLoadContestsRequested', this.loadContests);
        this.on(document, 'uiBrowseLoadCategoryCountRequested', this.loadCategoryCount);
    });

    var categoryParamFilterFunction = function(item) {
        return item.name === 'category';
    };

    var visibleParamFilterFunction = function(item) {
        var isCategory = item.name === 'category';
        var isDefaultValue = item.value === 'all';
        var isDefaultPage = item.name === 'page' && parseInt(item.value, 10) === 1;

        return !isCategory && !isDefaultValue && !isDefaultPage;
    };

    this.submit = function(url) {
        window.location.href = url;
    };

    this.getUrl = function(baseUrl, categoryUrl, params) {
        var url, categoryParams, visibleUrlParams;

        categoryParams = $.grep(params, categoryParamFilterFunction);
        visibleUrlParams = $.grep(params, visibleParamFilterFunction);

        if (categoryParams.length === 1 && categoryParams[0].value.toLowerCase() !== 'all') {
            url = categoryUrl.replace('/:category', '/' + categoryParams[0].value);
        } else {
            url = baseUrl;
        }

        return visibleUrlParams.length ? url + '?' + $.param(visibleUrlParams) : url;
    };

    this.getAjaxUrl = function(ajaxUrl, params) {
        return params.length ? ajaxUrl + '?' + $.param(params) : ajaxUrl;
    };

    this.loadContests = function(e, data) {
        var url = this.getUrl(data.url, data.categoryUrl, data.params),
            xhrUrl = this.getAjaxUrl(data.ajaxUrl, data.params);

        this.trigger('dataContestsWillLoad', { url: url });

        this.trigger('uiSpinnerShow');
        if (this.isHistoryApiSupported()) {
            if (listingXhr) {
                listingXhr.abort();
            }

            listingXhr = $.get(xhrUrl);
            listingXhr.done(
                function(res) {
                    this.trigger('dataContestsLoaded', [res]);
                    this.trigger('uiSpinnerHide');
                }.bind(this)
            );

            this.pushHistory(url);
        } else {
            this.submit(url);
        }
    };

    this.loadHistoryPage = function() {
        // Note: This is a very cheap way to get the filter elements updated when the back button is click.
        // This need to be refactored to update the page dynamically without an extra page load.
        window.location.reload();
    };

    this.loadCategoryCount = function(e, options) {
        if (options.path) {
            var url = options.params ? options.path + '?' + $.param(options.params) : options.path;

            if (countXhr) {
                countXhr.abort();
            }

            countXhr = $.ajax(url).done(
                function(res) {
                    this.trigger('dataBrowseCategoryCountLoaded', [res]);
                }.bind(this)
            );
        }
    };
}

export default defineComponent(contests, withHistory);



// WEBPACK FOOTER //
// ./src/web/js/browse/data/listings-pane.js